import { PackageActionContext } from '../../types/PackageActionContext';
import { PackageData } from '../../../types/package-data';

export const MAX_PORT_VALUE = 65535;
export const MIN_PORT_VALUE = 1;

export interface ProxyDataResponse {
  settings: {
    proxy: {
      enable: boolean;
      server?: string;
      port?: number;
      username?: string;
      password?: string;
    };
  };
}

export interface UseProxyFormViewMetadata {
  context: PackageActionContext;
  packageData: PackageData;
}
